import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Button,
} from "reactstrap";
import {
  POIacknowledge_close,
  POAcknowledgeInputChangeValue,
  SubmitPOiacknowledge,
  POClose_modal_open,POClose_modal_close,POCancelDescription,
  PurchaseOrderClose
} from "../../../store/PurchaseOrder/actions";
import { AvForm, AvField } from "availity-reactstrap-validation";
import swal from 'sweetalert';

class POcloseModel extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.ChangeHandeler = this.ChangeHandeler.bind(this);
  }
  ChangeHandeler(e) {
    this.props.POCancelDescription({
      key: e.target.name,
      value: e.target.value,
    });
  }
  handleValidSubmit() {
    const id = this.props.id
    const description = this.props.POClose_Model_Description
    this.props.PurchaseOrderClose(id,description)

  }
   handleClose = () =>{
    this.props.POClose_modal_close()
    swal({ title: "Your imaginary file is safe!", timer: 1500 });
  }
  render() {
  
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.POClose_Model}
          backdrop="static"
          centered
          size="lg"
        >
          <ModalBody>
            <AvForm
              className="form-horizontal"
              onValidSubmit={(e, v) => this.handleValidSubmit(e, v)}
              ref={(c) => (this.addForm = c)}
            >
              <FormGroup className="mb-0">
                <Label htmlFor="Remarks" className="col-form-label">
                  Reason to Close:
                </Label>
                <AvField
                  name="description"
                  id="description"
                  type="textarea"
                  className="form-control"
                  placeholder="Reason"
                  value={
                    this.props.POClose_Model_Description.description == null
                      ? ""
                      : this.props.POClose_Model_Description.description
                  }
                  rows="7"
                  validate={{
                    required: { value: true },
                  }}
                  onChange={this.ChangeHandeler}
                />
              </FormGroup>
              <div className="float-right">
                <Button
                  type="reset"
                  color="light"
                  className="waves-effect waves-light mr-2"
                  onClick={this.handleClose}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  color="primary"
                  className="waves-effect waves-light mr-2"
                 
                >
                  Submit
                </Button>
              </div>
            </AvForm>
          </ModalBody>
        </Modal>



      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { POIacknowledgeData, POIacknowledge_Model,POClose_Model,POClose_Model_Description } = state.PurchaseOrder;
  return {
    POIacknowledgeData,
    POIacknowledge_Model,
    POClose_Model,
    POClose_Model_Description

  };
};

export default connect(mapStatetoProps, {
  POIacknowledge_close,
  SubmitPOiacknowledge,
  POAcknowledgeInputChangeValue,
  POClose_modal_close,
  PurchaseOrderClose,
  POCancelDescription
})(POcloseModel);
